import React from 'react';
import { Container } from 'react-bootstrap';

const ResponsiveIframe = () => {



    return (

        <Container fluid>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d28848.518825126946!2d55.46970656723096!3d25.335604717782637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef5f5e36cfa2cc7%3A0x11f502f4edb88468!2sSharjah%20International%20Airport%20-%20Saif%20Zone%20-%20Sharjah%20-%20United%20Arab%20Emirates!5e0!3m2!1sen!2sin!4v1788437075611!5m2!1sen!2sin" width="100%" height="300"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </Container>
    );
};

export default ResponsiveIframe;
